import {
  createWalletProduct,
  deleteWalletProduct,
  getProductLine,
  getWalletProducts,
  updateWalletProduct
} from "../../../services/apiService";

const getErrorMessage = (err, fallback) =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  err?.message ||
  fallback;

export const getWalletProductLinesDATA = async (setLineOptions, userId) => {
  try {
    const resp = await getProductLine(userId);
    const data = resp?.data ?? resp;
    setLineOptions(data?.items || []);
  } catch (err) {
    console.error("Error consultando lineas de producto:", err);
    setLineOptions([]);
  }
};

export const getWalletProductsDATA = async ({
  page,
  pageSize,
  filters,
  setData,
  setTotal,
  setPage,
  setLoading,
  onError,
  userId
}) => {
  try {
    setLoading?.(true);
    const resp = await getWalletProducts({
      page,
      pageSize,
      search: filters?.search || "",
      lineId: filters?.lineId || null,
      userId
    });
    const data = resp?.data ?? resp;
    setData(Array.isArray(data?.items) ? data.items : []);
    setTotal(Number(data?.total) || 0);
    setPage(Number(data?.page) || page);
  } catch (err) {
    console.error("Error consultando productos cartera:", err);
    onError?.(
      getErrorMessage(err, "No se pudieron consultar los productos.")
    );
  } finally {
    setLoading?.(false);
  }
};

export const saveWalletProductDATA = async ({
  productId,
  payload,
  userId,
  onSuccess,
  onError
}) => {
  try {
    const resp = productId
      ? await updateWalletProduct(productId, payload, userId)
      : await createWalletProduct(payload, userId);
    const data = resp?.data ?? resp;
    onSuccess?.(data);
  } catch (err) {
    console.error("Error guardando producto cartera:", err);
    onError?.(getErrorMessage(err, "No se pudo guardar el producto."));
  }
};

export const deleteWalletProductDATA = async ({ productId, userId, onSuccess, onError }) => {
  try {
    const resp = await deleteWalletProduct(productId, userId);
    const data = resp?.data ?? resp;
    onSuccess?.(data);
  } catch (err) {
    console.error("Error eliminando producto cartera:", err);
    onError?.(getErrorMessage(err, "No se pudo eliminar el producto."));
  }
};
